/* ==========================================================================
   LOVE BOMB — hero carousel.

   Cross-fades stacked slides. Deliberately small: no dependencies, no layout
   thrash, and it stops entirely when the visitor has asked for reduced motion
   or the tab is hidden.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.lb-hero__slide'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lb-dot]'));
    var prev = root.querySelector('[data-lb-prev]');
    var next = root.querySelector('[data-lb-next]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    // Rotation is content, not decoration, so reduced-motion no longer blocks
    // it — the CSS drops the cross-fade to an instant swap instead, and the
    // carousel still pauses on hover and focus.
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        // aria-hidden on the offscreen slides keeps their links out of the
        // tab order while they are invisible
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
        s.querySelectorAll('a, button').forEach(function (el) {
          if (on) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
        var vid = s.querySelector('video');
        if (vid) {
          if (on) {
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            vid.pause();
          }
        }
      });
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-lb-dot'), 10));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // don't burn cycles animating a tab nobody is looking at
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { show(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    }, { passive: true });

    show(0);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-lb-hero-carousel]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // re-init when the theme editor swaps the section back in
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lb-hero-carousel]');
    if (root) initHero(root);
  });
})();
